import React from 'react'
import { QuizContextAction } from '../../contexts/quizContext'

type ProgressBarProps = {
  current: number
  total: number
  reduceQuizData: React.Dispatch<QuizContextAction>
}

const ProgressBar: React.FC<ProgressBarProps> = React.memo(
  ({ current, total, reduceQuizData }) => {
    const _onClick = (index: number) => {
      reduceQuizData({ type: 'set_quiz_index', payload: { quizIndex: index } })
      // console.log('click')
    }
    type DotProps = {
      index: number
    }
    const Dot: React.FC<DotProps> = ({ index }) => (
      <div
        className='Progress-bar-dot-individual-container'
        onClick={() => _onClick(index)}>
        <div className='Progress-bar-dot' />
      </div>
    )

    return (
      <div className='Progress-bar-container'>
        <div className='Progress-bar-status'>
          <div className='Progress-bar' style={{ flex: current }} />
          <div
            className='Progress-bar'
            style={{ flex: total - current, backgroundColor: 'transparent' }}
          />
        </div>
        <div className='Progress-bar-dot-container'>
          {[...Array(total).keys()].map((n) => (
            <Dot key={n} index={n} />
          ))}
        </div>
      </div>
    )
  },
)

export default ProgressBar
